import { createSelector } from 'reselect';

import { DeviceTypeState } from 'store/widgets/TradeInNewCalculator/deviceType/index';
import { convertListToObjectBy } from 'utils/fn';

import { selectTradeInNewWidgetCalculator } from '../common/selectors';

export const selectTradeInDeviceType = (state): DeviceTypeState =>
  selectTradeInNewWidgetCalculator(state).deviceType;

export const selectTradeInTypeTitle = (state) =>
  selectTradeInDeviceType(state).title;

export const selectTradeInTypeSelectedValue = (state) =>
  selectTradeInDeviceType(state).selectedValue;

export const selectTradeInTypeIsValid = (state) =>
  selectTradeInDeviceType(state).isValid;

export const selectTradeInTypeListForSelect = createSelector(
  selectTradeInDeviceType,
  (items) => items.data.map(type => ({
    slug: type.productFamily,
    label: type.title,
  })),
);

export const selectTradeInTypeBySlug = createSelector(
  selectTradeInTypeListForSelect,
  convertListToObjectBy('slug'),
);

export const selectTradeInTypeIsDisabled = (state) =>
  !selectTradeInTypeListForSelect(state).length;

export const selectTradeInTypeIsError = (state) =>
  !selectTradeInTypeIsValid(state) && !selectTradeInTypeIsDisabled(state);
